"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var injectIntl_1 = require("./injectIntl");
var utils_1 = require("../utils");
function useIntl() {
    var intl = React.useContext(injectIntl_1.Context);
    utils_1.invariantIntlContext(intl);
    return intl;
}
exports.default = useIntl;
//# sourceMappingURL=useIntl.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-intl/dist/components/useIntl.js
// module id = 818
// module chunks = 168707334958949